/** notify: the notification bell (Phase 17.12). Arabic is a draft for native review. */
const en = {
  "bell": "Notifications",
  "bellUnread": "Notifications: {n} new",
  "title": "Notifications",
  "all": "Open Health Check",
  "empty": "No problems in the last 14 days.",
  "new": "New",
  "fixed": "fixed",
  "loading": "Loading…",
  "whatsWrong": "What's wrong",
  "reason": "Reason",
  "detail": "Detail",
  "since": "Since",
  "reportedBy": "Reported by",
  "usedIn": "Where it's used",
  "notUsed": "Not used in any campaign, playlist or player.",
  "inCampaign": "Campaign",
  "inPlaylist": "Playlist",
  "onPlayer": "Player",
  "fixHint": "Players skip this item and keep playing the rest; they retry the file by themselves. To fix it, upload a working file and put it in place of this one where it's used, or delete this item.",
  "openInLibrary": "Open in library",
  "filesTitle": "{n} content file failed | {n} content files failed",
  "filesIntro": "This player couldn't download or check these items (since {since}). It keeps playing everything else and retries them by itself.",
  "filesUnknown": "The player hasn't said which items yet; it will on its next report (within a minute).",
  "filesHint": "Usually the file was deleted or its address changed: upload it again and put the new item in place of the old one, or remove the item.",
  "whyUnknown": "failed to download",
  "deletedItem": "Deleted item",
  "details": "Details",
  "playerLog": "Player's error log",
  "viewIssue": "View issue",
  "openFor": "Open for {since}",
  "facts": "Details",
  "autoResolve": "Health Check re-checks every minute and marks this resolved by itself once the problem is gone.",
  "fixIt": "Fix it",
  "fixImpact": "Changes {impact}. Each place keeps its own settings (duration, transition, fit).",
  "nCampaigns": "{n} campaign | {n} campaigns",
  "nPlaylists": "{n} playlist | {n} playlists",
  "nPlayers": "{n} player | {n} players",
  "replaceWith": "Replace with another item",
  "uploadNew": "Upload a new file",
  "removeEverywhere": "Remove it everywhere",
  "searchLibrary": "Search your library",
  "noCandidates": "No ready items match.",
  "replace": "Replace",
  "remove": "Remove",
  "replaceQ": "Put “{to}” in place of “{from}” everywhere it's used? This changes {impact}.",
  "uploadQ": "Upload “{file}” as a new version of “{name}” and put it everywhere the old one is used? This changes {impact}. The old item stays in your library.",
  "removeQ": "Take “{name}” out of everything that uses it? This changes {impact}. The item stays in your library.",
  "replaced": "“{name}” now plays in its place ({n} place) | “{name}” now plays in its place ({n} places)",
  "removed": "Removed from everything; {n} player updated | Removed from everything; {n} players updated",
  "undone": "Put back as it was",
  "uploading": "Uploading {name}…",
  "preparing": "Preparing {name} for the players…"
};
const ar: typeof en = {
  "bell": "الإشعارات",
  "bellUnread": "الإشعارات: {n} جديدة",
  "title": "الإشعارات",
  "all": "فتح فحص الحالة",
  "empty": "لا توجد مشكلات خلال آخر 14 يومًا.",
  "new": "جديد",
  "fixed": "تم الإصلاح",
  "loading": "جارٍ التحميل…",
  "whatsWrong": "ما المشكلة",
  "reason": "السبب",
  "detail": "التفاصيل",
  "since": "منذ",
  "reportedBy": "أبلغ عنها",
  "usedIn": "أين يُستخدم",
  "notUsed": "غير مستخدم في أي حملة أو قائمة تشغيل أو مشغّل.",
  "inCampaign": "حملة",
  "inPlaylist": "قائمة تشغيل",
  "onPlayer": "مشغّل",
  "fixHint": "تتخطى المشغّلات هذا العنصر وتواصل تشغيل الباقي، وتعيد محاولة تنزيل الملف تلقائيًا. لإصلاحه، ارفع ملفًا سليمًا وضعه مكان هذا العنصر حيث يُستخدم، أو احذف هذا العنصر.",
  "openInLibrary": "فتح في المكتبة",
  "filesTitle": "تعذّر ملف محتوى واحد | تعذّر {n} من ملفات المحتوى",
  "filesIntro": "لم يتمكن هذا المشغّل من تنزيل هذه العناصر أو التحقق منها (منذ {since}). يواصل تشغيل كل شيء آخر ويعيد المحاولة تلقائيًا.",
  "filesUnknown": "لم يحدد المشغّل العناصر بعد؛ سيفعل في تقريره التالي (خلال دقيقة).",
  "filesHint": "غالبًا حُذف الملف أو تغيّر عنوانه: ارفعه مجددًا وضع العنصر الجديد مكان القديم، أو أزل العنصر.",
  "whyUnknown": "تعذّر التنزيل",
  "deletedItem": "عنصر محذوف",
  "details": "التفاصيل",
  "playerLog": "سجل أخطاء المشغّل",
  "viewIssue": "عرض المشكلة",
  "openFor": "مفتوحة منذ {since}",
  "facts": "التفاصيل",
  "autoResolve": "يعيد فحص الحالة التحقق كل دقيقة ويضع علامة «تم الحل» تلقائيًا عند زوال المشكلة.",
  "fixIt": "إصلاح",
  "fixImpact": "يغيّر {impact}. يحتفظ كل موضع بإعداداته (المدة، الانتقال، الملاءمة).",
  "nCampaigns": "حملة واحدة | {n} حملات",
  "nPlaylists": "قائمة تشغيل واحدة | {n} قوائم تشغيل",
  "nPlayers": "مشغّل واحد | {n} مشغّلات",
  "replaceWith": "استبدال بعنصر آخر",
  "uploadNew": "رفع ملف جديد",
  "removeEverywhere": "إزالته من كل مكان",
  "searchLibrary": "ابحث في مكتبتك",
  "noCandidates": "لا توجد عناصر جاهزة مطابقة.",
  "replace": "استبدال",
  "remove": "إزالة",
  "replaceQ": "هل تضع «{to}» مكان «{from}» في كل مكان يُستخدم فيه؟ يغيّر هذا {impact}.",
  "uploadQ": "هل ترفع «{file}» كنسخة جديدة من «{name}» وتضعها في كل مكان يُستخدم فيه القديم؟ يغيّر هذا {impact}. يبقى العنصر القديم في مكتبتك.",
  "removeQ": "هل تُخرج «{name}» من كل ما يستخدمه؟ يغيّر هذا {impact}. يبقى العنصر في مكتبتك.",
  "replaced": "يُعرض «{name}» الآن مكانه (موضع واحد) | يُعرض «{name}» الآن مكانه ({n} مواضع)",
  "removed": "أُزيل من كل مكان؛ حُدّث مشغّل واحد | أُزيل من كل مكان؛ حُدّث {n} مشغّلات",
  "undone": "أُعيد كما كان",
  "uploading": "جارٍ رفع {name}…",
  "preparing": "جارٍ تجهيز {name} للمشغّلات…"
};
export default { en, ar };
